import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetSubscriptionPlans,
	IResponseGetSubscriptionPlans,
} from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { getSubscriptionPlansURL } from "../../../utils/constants"

async function getSubscriptionPlans(
	{ ...rest }: IPropsGetSubscriptionPlans,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetSubscriptionPlans> =
			await apiPrivate.get(`${getSubscriptionPlansURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetSubscriptionPlans(
	data: IPropsGetSubscriptionPlans,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetSubscriptionPlans,
					unknown,
					IResponseGetSubscriptionPlans
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETSUBSCRIPTIONPLAN, ...Object.values(data)],
		queryFn: () => getSubscriptionPlans(data, apiPrivate),
		...options,
	})
}
